import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import DenunciaAnonima from './pages/DenunciaAnonima';
import DenunciaIdentificada from './pages/DenunciaIdentificada';
import Acompanhamento from './pages/Acompanhamento';
import QRRedirect from './pages/QRRedirect';
import Manifestacao from './pages/Manifestacao';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import TermosUso from './pages/TermosUso';
import Transparencia from './pages/Transparencia';
import './styles/index.css';

function App() {
  return (
    <BrowserRouter>
      <div className="page">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/denuncia-anonima" element={<DenunciaAnonima />} />
          <Route path="/denuncia-identificada" element={<DenunciaIdentificada />} />
          <Route path="/manifestacao/:tipo" element={<Manifestacao />} />
          <Route path="/acompanhamento" element={<Acompanhamento />} />
          <Route path="/r/:codigo" element={<QRRedirect />} />
          <Route path="/privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/termos" element={<TermosUso />} />
          <Route path="/transparencia" element={<Transparencia />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
